/* Progressive enhancement: all quantities remain available without JavaScript. */
(function () {
  /* Five-choice: the compare row is a fixed top four plus slot five. Slot five is the
     product the visitor ORIGINALLY landed on when that product is outside the top four.
     The server (ha-winter-product.liquid) already puts the viewed product in slot five
     when it is outside the top four. Here we remember that card per product family in
     sessionStorage and put it back in slot five on the top-four pages the visitor then
     clicks to, so the landing product does not disappear. Must run before the compare
     rail is built (ha-winter-details reads the first five .fam-row .fam-c at
     DOMContentLoaded; this file is deferred, so it runs first). */
  function fiveChoice(scope) {
    var LABEL = { en: 'Where you started', de: 'Dein Einstieg', nl: 'Hier begon je' };
    scope.querySelectorAll('.fam--pdp').forEach(function (shelf) {
      if (shelf.dataset.fiveChoice) return;
      var row = shelf.querySelector('.fam-row');
      if (!row) return;
      var cards = Array.prototype.slice.call(row.querySelectorAll('.fam-c[data-ha-key]'));
      if (cards.length < 5) return;
      shelf.dataset.fiveChoice = 'true';
      var link = shelf.querySelector('.fam-crumb a:last-of-type');
      var path = '';
      try {
        path = link ? new URL(link.getAttribute('href'), location.href).pathname : '';
        /* The shelf link can carry a product handle (/collections/<shelf>/products/<x>); the family is the shelf. */
        var m = path.match(/\/collections\/([^\/]+)/);
        if (m) path = m[1];
      } catch (e) {}
      if (!path) return;
      var storeKey = 'ha-five:' + ((document.documentElement.lang || 'x').slice(0, 2)) + ':' + path;
      var slot5 = cards[4];
      var keys = cards.map(function (c) { return c.getAttribute('data-ha-key'); });
      var stored = null;
      try { stored = JSON.parse(sessionStorage.getItem(storeKey) || 'null'); } catch (e) {}
      var landed = slot5.classList.contains('on') && slot5.getAttribute('data-ha-rank') === 'came';
      if (landed) {
        /* Visitor is on a product outside the top four: it is slot five and the anchor. */
        try {
          sessionStorage.setItem(storeKey, JSON.stringify({ key: slot5.getAttribute('data-ha-key'), html: slot5.outerHTML }));
        } catch (e) {}
        return;
      }
      if (!stored || !stored.key || !stored.html) return;
      /* No duplicates: skip when the anchor is now in the top four or is this very page. */
      if (keys.indexOf(stored.key) > -1) return;
      var tpl = document.createElement('template');
      tpl.innerHTML = String(stored.html).trim();
      var card = tpl.content.firstElementChild;
      if (!card || !card.classList.contains('fam-c') || card.getAttribute('data-ha-key') !== stored.key) return;
      var href = card.getAttribute('href') || '';
      if (href.charAt(0) !== '/' || href.charAt(1) === '/') return;
      card.classList.remove('on');
      card.removeAttribute('aria-current');
      var rank = card.querySelector('.fam-rank');
      if (rank) {
        var lang = (document.documentElement.lang || 'en').toLowerCase().split('-')[0];
        rank.textContent = LABEL[lang] || LABEL.en;
        rank.className = 'fam-rank came';
      }
      card.setAttribute('data-ha-rank', 'came');
      slot5.replaceWith(card);
    });
  }
  function init(scope) {
    fiveChoice(scope);
    scope.querySelectorAll('.fam--pdp').forEach(function (shelf) {
      if (shelf.querySelector('.ha-shelf-picker')) return;
      var row = shelf.querySelector('.fam-row');
      if (!row) return;
      var language = (document.documentElement.lang || 'en').split('-')[0];
      var picker = document.createElement('details');
      picker.className = 'ha-shelf-picker';
      var summary = document.createElement('summary');
      summary.textContent = {de:'Alle 5 Modelle vergleichen',nl:'Vergelijk alle 5 opties',en:'Compare all 5 options'}[language] || 'Compare all 5 options';
      picker.appendChild(summary);
      row.before(picker);
      picker.appendChild(row);
      var foot = shelf.querySelector('.fam-foot');
      if (foot) picker.appendChild(foot);
      picker.open = true;
    });
    scope.querySelectorAll('[data-ha-compare]').forEach(function (section) {
      var wrap = section.querySelector('.wrap');
      if (!wrap || wrap.querySelector('.ha-compare-toggle')) return;
      var language = (document.documentElement.lang || 'en').toLowerCase().split('-')[0];
      var labels = { en: 'Compare the options', de: 'Modelle vergleichen', nl: 'Vergelijk de opties' };
      var details = document.createElement('details');
      details.className = 'ha-compare-toggle';
      details.open = true;
      var summary = document.createElement('summary');
      summary.textContent = labels[language] || labels.en;
      details.appendChild(summary);
      while (wrap.firstChild) details.appendChild(wrap.firstChild);
      wrap.appendChild(details);
      function openFromHash() {
        if (location.hash === '#' + section.id) details.open = true;
      }
      openFromHash();
      window.addEventListener('hashchange', openFromHash);
      document.querySelectorAll('a[href="#' + section.id + '"]').forEach(function (link) {
        link.addEventListener('click', function () { details.open = true; });
      });
    });
    scope.querySelectorAll('[data-ha-product]').forEach(function (root) {
      if (root.dataset.croReady) return;
      root.dataset.croReady = 'true';
      var price = root.querySelector('[data-ha-price]');
      var heroPrice = root.querySelector('[data-ha-hero-price]');
      if (price && heroPrice) {
        var heroCurrent = heroPrice.querySelector('[data-ha-hero-current]');
        var heroCompare = heroPrice.querySelector('[data-ha-hero-compare]');
        var heroWas = heroPrice.querySelector('[data-ha-hero-was]');
        var heroRrp = heroPrice.querySelector('[data-ha-hero-rrp]');
        var heroPct = heroPrice.querySelector('[data-ha-hero-pct]');
        var pct = root.querySelector('[data-ha-pct]');
        var was = root.querySelector('[data-ha-was]');
        var wasWrap = root.querySelector('[data-ha-wasw]');
        var rrp = root.querySelector('[data-ha-rrp]');
        var sync = function () {
          (heroCurrent || heroPrice).textContent = price.textContent;
          if (!heroCompare || !heroWas) return;
          var showCompare = !!(was && wasWrap && !was.hidden && !wasWrap.hidden && was.textContent.trim());
          heroWas.textContent = showCompare ? was.textContent : '';
          heroCompare.hidden = !showCompare;
          if (heroRrp) { heroRrp.textContent = ''; heroRrp.hidden = true; }
          if (heroPct) {
            var showPct = showCompare && pct && !pct.hidden && pct.textContent.trim();
            heroPct.textContent = showPct ? pct.textContent : '';
            heroPct.hidden = !showPct;
          }
        };
        sync();
        new MutationObserver(sync).observe(price.parentElement, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['hidden'] });
      }
      root.querySelectorAll('[data-ha-pack]').forEach(function (pack) {
        var buttons = Array.from(pack.querySelectorAll('button[data-ha-qty]'));
        if (root.querySelector('[data-ha-sizeguide]')) {
          var sizeNote = document.createElement('p');
          sizeNote.className = 'ha-pack-size-note';
          var noteLang = (document.documentElement.lang || 'en').split('-')[0];
          sizeNote.textContent = {de:'Alle Stücke im Pack haben die oben gewählte Größe.',nl:'Alle artikelen in het pakket hebben de hierboven gekozen maat.',en:'All items in the pack use the size selected above.'}[noteLang] || 'All items in the pack use the size selected above.';
          pack.appendChild(sizeNote);
          function syncSizeNote() { var selected = buttons.find(function(b){return b.getAttribute('aria-pressed') === 'true';}); sizeNote.hidden = !selected || Number(selected.dataset.haQty) <= 1; }
          syncSizeNote();
          buttons.forEach(function(b){new MutationObserver(syncSizeNote).observe(b,{attributes:true,attributeFilter:['aria-pressed']});});
        }
        /* Per-product pack layout (Lou, 13 Oct 2026). open: all tiers visible, no "more" toggle.
           badges: fixed label per quantity; replaces the computed "best price per piece" badge on that tier. */
        var PACK_UI = {
          'stretch-cargo-men': { open: true, hideDesc: true, compareWas: true, noEach: true, saveInline: true, buyLabel: { en: 'Buy {n}', de: '{n} kaufen', nl: 'Koop {n}' }, badges: {
            2: { en: 'Most chosen', de: 'Meistgewählt', nl: 'Meest gekozen' },
            3: { en: 'Best value', de: 'Bester Preis', nl: 'Beste deal' } } },
          'ha-combat-trousers-men': { open: true, hideDesc: true, compareWas: true, noEach: true, saveInline: true, buyLabel: { en: 'Buy {n}', de: '{n} kaufen', nl: 'Koop {n}' }, badges: {
            2: { en: 'Most chosen', de: 'Meistgewählt', nl: 'Meest gekozen' },
            3: { en: 'Best value', de: 'Bester Preis', nl: 'Beste deal' } } }
        };
        var packUi = PACK_UI[root.dataset.haProduct];
        if (packUi) {
          /* hideDesc: no "One item / Multiple items in one order" line. compareWas: each tier strikes its own
             variant compare-at (same for every colour and size of that tier) instead of the computed singles x n. */
          if (packUi.noEach || packUi.saveInline) {
            if (!document.getElementById('ha-pack-ui-css')) {
              var css = document.createElement('style');
              css.id = 'ha-pack-ui-css';
              css.textContent = '.ha-pk-noeach [data-ha-sep],.ha-pk-noeach [data-pk-each]{display:none!important}'
                + '.ha-pk-nrow{display:flex;flex-wrap:wrap;align-items:center;gap:4px 8px}.ha-pk-nrow .ha-pk-s{margin:0}';
              document.head.appendChild(css);
            }
            if (packUi.noEach) root.classList.add('ha-pk-noeach');
          }
          if (packUi.hideDesc) buttons.forEach(function (b) { b.querySelectorAll('.ha-pk-d').forEach(function (e) { e.remove(); }); });
          if (packUi.compareWas) {
            var vsel = root.querySelector('[data-ha-variants]');
            buttons.forEach(function (b) {
              var opt = vsel && Array.prototype.find.call(vsel.options, function (o) {
                try { var v = JSON.parse(o.getAttribute('data-values')); return v[v.length - 1] === b.dataset.haVal && o.getAttribute('data-was'); } catch (e) { return false; }
              });
              var tot = b.querySelector('.ha-pk-t');
              if (!opt || !tot) return;
              var ws = b.querySelector('[data-pk-was]');
              if (ws) ws.remove();
              var s = document.createElement('s');
              s.setAttribute('data-pk-fixed-was', '');
              s.textContent = opt.getAttribute('data-was');
              tot.insertBefore(s, tot.firstChild);
              /* Pack tiers: the pill states the total saving against this tier's own compare-at, per currency.
                 The theme's computed pill ("x% extra" vs singles) is removed; packPrices() null-checks it. */
              if (Number(b.dataset.haQty) > 1) {
                var sv = b.querySelector('[data-pk-save]');
                if (sv) sv.remove();
                var was = Number(opt.getAttribute('data-was-cents')), cur = Number(opt.getAttribute('data-cents'));
                var pctOff = was > cur ? Math.round((was - cur) / was * 100) : 0;
                if (pctOff > 0) {
                  var pill = document.createElement('span');
                  pill.className = 'ha-pk-s';
                  pill.setAttribute('data-pk-fixed-save', '');
                  pill.textContent = ({ en: 'Save', de: 'Spare', nl: 'Bespaar' }[(document.documentElement.lang || 'en').toLowerCase().split('-')[0]] || 'Save') + ' ' + pctOff + '%';
                  var right = b.querySelector('.ha-pk-r'), lbl = b.querySelector('.ha-pk-n');
                  if (packUi.saveInline && lbl) {
                    var nrow = document.createElement('span');
                    nrow.className = 'ha-pk-nrow';
                    lbl.parentNode.insertBefore(nrow, lbl);
                    nrow.appendChild(lbl);
                    nrow.appendChild(pill);
                  } else if (right) right.appendChild(pill);
                }
              }
            });
          }
          var uiLang = (document.documentElement.lang || 'en').toLowerCase().split('-')[0];
          buttons.forEach(function (b) {
            var t = packUi.badges && packUi.badges[b.dataset.haQty];
            if (!t) return;
            var old = b.querySelector('[data-pk-badge]');
            if (old) old.remove();
            var badge = document.createElement('span');
            badge.className = 'ha-pk-b';
            badge.setAttribute('data-pk-fixed', '');
            badge.textContent = t[uiLang] || t.en;
            b.appendChild(badge);
          });
          if (packUi.buyLabel) {
            if (!document.getElementById('ha-pack-buy-css')) {
              var bcss = document.createElement('style');
              bcss.id = 'ha-pack-buy-css';
              bcss.textContent = '.ha-pk-buylbl .ha-pk-n{display:none}.ha-pk-buy{font:600 14.5px/1.2 var(--ha-body);color:var(--ha-slate)}'
                + '@media (max-width:430px){.ha-pk-buy{font-size:14px}}';
              document.head.appendChild(bcss);
            }
            var bLang = (document.documentElement.lang || 'en').toLowerCase().split('-')[0];
            var bTpl = packUi.buyLabel[bLang] || packUi.buyLabel.en;
            buttons.forEach(function (b) {
              var n = b.querySelector('.ha-pk-n');
              if (!n || b.querySelector('.ha-pk-buy')) return;
              var buy = document.createElement('span');
              buy.className = 'ha-pk-buy';
              buy.textContent = bTpl.replace('{n}', b.dataset.haQty);
              n.parentNode.insertBefore(buy, n);
              b.classList.add('ha-pk-buylbl');
            });
          }
          if (packUi.open) return;
        }
        var family = root.dataset.haCro;
        var singleFirst = ['the-sherpa-full-zip-women','the-insulated-pullover','the-thermal-legging'].includes(root.dataset.haProduct);
        var limit = root.dataset.haProduct === 'the-thermal-legging' ? 3 :
          (singleFirst || ['rain', 'fleece', 'grid', 'heated'].includes(family) ? 1 : 2);
        if (buttons.length <= limit) return;
        var extras = buttons.slice(limit);
        var control = document.createElement('button');
        control.type = 'button';
        control.className = 'ha-pack-more';
        var moreLabel = root.dataset.morePacks;
        var language = (document.documentElement.lang || 'en').toLowerCase().split('-')[0];
        var hideLabel = { en: 'Hide', de: 'Ausblenden', nl: 'Verbergen' }[language] || 'Hide';
        control.setAttribute('aria-expanded', 'false');
        var open = false;
        function show(value) {
          open = value;
          extras.forEach(function (button) { button.hidden = !open; });
          control.textContent = open ? hideLabel : moreLabel;
          control.setAttribute('aria-expanded', String(open));
        }
        control.addEventListener('click', function () { show(!open); });
        pack.appendChild(control);
        show(extras.some(function (button) { return button.getAttribute('aria-pressed') === 'true'; }));
        // URL-selected variants and subsequent variant changes must never hide the selection.
        var observer = new MutationObserver(function () {
          if (!open && extras.some(function (button) { return button.getAttribute('aria-pressed') === 'true'; })) show(true);
        });
        buttons.forEach(function (button) { observer.observe(button, { attributes: true, attributeFilter: ['aria-pressed'] }); });
      });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
